import React from 'react'

export default function ReceiptsListInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .receipts-list-table-container {
          /*padding: 5px 5px;*/
          border: solid 0.5px lightgrey;
          font-size: 1rem;
        }

        .title-header {
          display: flex;
        }
        .title-header:hover {
          cursor: pointer;
        }
        .title-header div {
          flex: 2;
        }
        .title-header span {
          text-align: right;
        }
      `}
      </style>
    </React.Fragment>
  )
}
